import * as Sentry from '@sentry/react'
import { envConfig } from '../config'

export const initSentry = () => {
  const { keycloak, sentry } = envConfig()
  // sometimes, like in localhost we might not want sentry all the time
  if (!sentry.dsn) {
    return
  }

  // Determine environment based on Keycloak base URL
  const environment =
    keycloak.baseUrl === 'https://auth.bloomwell.de' ? 'production' : 'staging'

  Sentry.init({
    dsn: sentry.dsn,
    environment,
    // Session Replay was configured here and nobody watched the recordings, so
    // it is removed rather than left shipping ~200 kB gzipped to every page
    // load. Re-adding it means restoring replayIntegration plus the
    // replays*SampleRate options - and the GDPR masking that went with them
    // (maskAllText/maskAllInputs/blockAllMedia), since this service renders
    // payment data.
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,

    // Release tracking
    release: import.meta.env.REACT_APP_GIT_COMMIT_HASH,

    // PII protection
    sendDefaultPii: false,

    beforeSend(event) {
      // Filter out non-error console logs
      if (event.level === 'log' || event.level === 'info') {
        return null
      }
      // Adyen Web mounts card fields and the 3DS challenge in cross-origin
      // iframes, and its SDK internals reach into them on load. The browser
      // refuses, we get a SecurityError we cannot act on, and it is thrown from
      // minified third-party code so there is nothing to fix on our side.
      // Wording differs per browser (Chrome "cross-origin frame", Firefox
      // "cross-origin object", Safari "Blocked a frame"), hence the loose match.
      if (
        event.exception?.values?.some(
          (e) =>
            e.type === 'SecurityError' &&
            typeof e.value === 'string' &&
            /cross-origin|Blocked a frame/i.test(e.value)
        )
      ) {
        return null
      }
      return event
    }
  })
}
